import { axiosInstance as request } from '@api/rest.service'

const api = '/emails'
/**
 * @description GET /emails
 * @returns {AxiosPromise<any>}
 */
export const GET_EMAILS = () => request.get(api)

/**
 * @description GET /emails?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_EMAILS = params => request.get(`${api}?paginated=true`, { params })

/**
 * @description GET /emails/${id}
 * @returns {AxiosPromise<any>}
 */
export const GET_EMAIL = id => request.get(`${api}/${id}`)
